import { useState } from "react";
import { api } from "../../../service/api";
import { SimulatorUserDTO } from "../../../dtos/SimulatorUserDTO";

export function useSimulatorUser() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [dataList, setDataList] = useState<SimulatorUserDTO[]>([]);

  const fetchData = async (id: string) => {
    try {
      setLoading(true);
      const response = await api.get(`/simulators/questions/list/${id}`);
      setDataList(response.data);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return {
    dataList,
    loading,
    error,
    refetch: fetchData,
  };
}
